<template>
  <div class="bg-payment" style="min-height: 100vh">
    <div class="logo text-center bg-transparent">
      <slot name="logo">
        <img src="@/assets/images/bulle-payment.png" alt />
      </slot>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {},
}
</script>

<style lang="scss" scoped>
.bg-payment {
  background-image: url('~@/assets/images/bg-payment.png');
  background-size: cover;
}

.logo {
  padding-top: 10px;
  img {
    height: 374px;
    width: 374px;
  }
}
</style>
